export function downloadLink(link, fileName) {
  let anchor = document.createElement("a");
  anchor.id = "temp_id_download_link";
  anchor.href = link;
  anchor.target = "_blank";
  if (fileName) {
    anchor.download = fileName;
  }
  document.body.appendChild(anchor);
  anchor.click();
  anchor = null;
  document.body.removeChild(document.getElementById("temp_id_download_link"));
}

export function formatTime(seconds) {
  if (!seconds) {
    return "00:00:00";
  }
  let h = 0,
    m = 0,
    s = 0;
  h = Math.floor(seconds / 3600);
  h = h < 10 ? `0${h}` : h;
  m = Math.floor((seconds % 3600) / 60);
  m = m < 10 ? `0${m}` : m;
  s = Math.floor(seconds % 60);
  s = s < 10 ? `0${s}` : s;
  return `${h}:${m}:${s}`;
}

export function loadScript(url) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error("param url miss"));
    }
    const scriptEl = document.createElement("script");
    scriptEl.src = url;
    scriptEl.onload = function () {
      resolve(true);
    };
    scriptEl.onerror = function () {
      reject(new Error("load script error"));
    };
    document.head.appendChild(scriptEl);
  });
}

function hideSelector(selector) {
  let els = document.querySelectorAll(selector);
  for (let i = 0; i < els.length; i++) {
    let el = els[i];
    el.style.display = "none";
  }
}
function isApp() {
  // ?display_template&isapp=1
  let str = location.search || "";
  str = str.replace("&", "?");
  let arr = str.split("?");
  let key = "";
  for (let i = 0; i < arr.length; i++) {
    key = arr[i].split("=")[0];
    if (key == "isapp") {
      return true;
    }
  }
  return false;
}
export function hideHeaderFooterInApp() {
  // isapp 隐藏 header footer
  let isHide = false;
  // isapp
  isHide = isApp();
  if (isHide) {
    document.body.classList.add("hide-header-footer");
    hideSelector(".ap-header,.ap-footer");
  } else {
    let headrEl = document.querySelector(".ap-header");
    if (headrEl) {
      headrEl.style.opacity = 1;
    }
  }
}

export function filetoDataURL(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = (e) => resolve(e.target.result);
    reader.readAsDataURL(file);
  });
}
